module.exports = __webpack_public_path__ + "static/media/banner_7up7down-halfnew.394976b6.png";